<div class="header">
    <h2>{{ 'pathways.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="pathways-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'pathways.error.unavailable' | translate" />
} @else if (pathway(); as pathway) {
    <div class="body">
        <div class="entity-header">
            <div class="entity-identity">
                <h1>{{ pathway.name }}</h1>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'pathways.fieldset.basic' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'pathways.form.name' | translate }}</span>
                <span class="value">{{ pathway.name }}</span>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'pathways.form.school' | translate }}</h2>
            <app-entity-list [ids]="pathway.schoolIds" type="school" emptyKey="pathways.schools.empty" />
        </div>

        <div class="section">
            <h2>{{ 'pathways.form.courses' | translate }}</h2>
            <app-entity-list [ids]="pathway.courseIds" type="course" emptyKey="pathways.courses.empty" />
        </div>

        <div class="section">
            <h2>{{ 'pathways.fieldset.stats' | translate }}</h2>
            <div class="row">
                <div class="field">
                    <span class="label">{{ 'pathways.form.users' | translate }}</span>
                    <span class="value">{{ pathway.userIds.length }}</span>
                </div>
                <div class="field">
                    <span class="label">{{ 'pathways.form.courses' | translate }}</span>
                    <span class="value">{{ pathway.courseIds.length }}</span>
                </div>
            </div>
        </div>
    </div>
}
